import { SiteSettings } from './types';

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const getActiveDiscountPercentage = (settings?: SiteSettings | null): number => {
  if (!settings) return 0;
  const pct = settings.globalDiscountPercentage;
  if (!pct || pct <= 0) return 0;
  
  const until = settings.globalDiscountUntil;
  if (until) {
    const untilDate = new Date(until);
    if (isNaN(untilDate.getTime()) || untilDate.getTime() < Date.now()) {
      return 0; // expired
    }
  }
  return Math.min(100, Math.max(0, pct));
};

export const getDiscountedPrice = (price: number, discountPercentage: number): number => {
  if (discountPercentage <= 0) return price;
  return price * (1 - discountPercentage / 100);
};
